import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

// Attach JWT token on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('psf_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && typeof window !== 'undefined') {
      const path = window.location.pathname;
      if (path.startsWith('/admin') && path !== '/admin/login') {
        localStorage.removeItem('psf_token');
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

export const SPORTS = [
  'Athletics', 'Cricket', 'Football', 'Kabaddi', 'Kho-Kho', 'Badminton',
  'Table Tennis', 'Volleyball', 'Basketball', 'Wrestling', 'Boxing',
  'Judo', 'Karate', 'Taekwondo', 'Swimming', 'Chess', 'Hockey',
  'Weightlifting', 'Archery', 'Shooting',
];

export const FEDERATION = {
  name: 'Players Sports Federation',
  short: 'PSF',
  email: 'psfindia.in@gmail.com',
  phone: '8982 20 4590',
  reg: 'MP-200097570',
  ministryLine: 'FIT-INDIA MINISTRY OF YOUTH & AFFAIRS GOVT OF INDIA',
};

export const PGSF_EMBLEM = 'https://static.prod-images.emergentagent.com/jobs/f13ee9ac-fe3c-4f59-b407-1194656ed5d3/images/cbcd956a462ab7cbe3ef2168197fdbcbb58872f2155f93e44fa8ef0e69cd3910.jpeg';
export const UPI_QR_IMAGE = 'https://customer-assets-4nw71qhi.emergentagent.net/job_player-qr-payment-1/artifacts/39mna845_WhatsApp%20Image%202026-08-07%20at%201.58.11%20PM.jpeg';
